/*
 * File: tab.ts
 * File Created: 2024-02-02 01:33:40
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:49:59
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Tab extends BaseComponent {
    @Prop({ type: Boolean, default: false })
    active!: boolean;

    @Prop({ type: Boolean, default: true })
    lazy!: boolean;

    /// public slots
    publicSlots = {
        label: "@label",
    };
}
